export default {
  Verified: 'Verified',
  CaregiverType: {
    PSW: 'Personal Support Worker',
    DSW: 'Developmental Support Worker',
    RN: 'Registered Nurse',
    PAB: 'Préposé aux bénéficiaires',
    CNA: 'Certified Nursing Assistant',
    RPN: 'Registered Practical Nurse',
    RNA: 'Registered Nursing Assistant',
    HCA: 'Health Care Aide',
    pswStudent: 'Personal Support Worker Student',
    nursingStudent: 'Nursing Student',
    unaccredited: 'Caregiving Companion',
  },
  ResponseTime: 'Typically responds within 2 hours',
  PersonalBioSubtitle: 'Personal Story',
  CaregiverMotivationSubtitle: 'Caregiver Motivation',
  Languages: 'Languages',
  AvailableLanguages: {
    English: 'English',
    French: 'French',
    Mandarin: 'Mandarin',
    Cantonese: 'Cantonese',
    Hindustani: 'Hindustani',
    Spanish: 'Spanish',
    Punjabi: 'Punjabi',
    Arabic: 'Arabic',
    Tagalog: 'Tagalog',
    Italian: 'Italian',
    German: 'German',
    Portuguese: 'Portuguese',
    Persian: 'Persian',
    Russian: 'Russian',
    Tamil: 'Tamil',
    Vietnamese: 'Vietnamese',
    Gujarati: 'Gujarati',
    Polish: 'Polish',
    Korean: 'Korean',
    SerboCroatian: 'Serbo-Croatian',
    Greek: 'Greek',
    HaitianCreole: 'Haitian Creole',
    Ukrainian: 'Ukrainian',
    Bengali: 'Bengali',
    Romanian: 'Romanian',
    Dutch: 'Dutch',
    Cree: 'Cree',
    Japanese: 'Japanese',
    Hebrew: 'Hebrew',
    Turkish: 'Turkish',
    Malayalam: 'Malayalam',
    Hungarian: 'Hungarian',
    Ilocano: 'Ilocano',
    Somali: 'Somali',
    Swahili: 'Swahili',
    Telugu: 'Telugu',
    Other: 'Other Language',
  },
  Fluency: {
    Basic: 'Basic',
    Conversational: 'Conversational',
    Fluent: 'Fluent',
    Native: 'Native',
  },
};
